// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: models/image.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../google/protobuf/timestamp";
import { SoftwareMode, softwareModeFromJSON, softwareModeToJSON } from "./fabric";
import { ImageAvailabilityType, imageAvailabilityTypeFromJSON, imageAvailabilityTypeToJSON } from "./global";

export const protobufPackage = "models";

/** FabricImageUpdate describes the image configurations */
export interface FabricImageUpdate {
  /** The fabric id */
  fabricId: string;
  /** The image update tag */
  tag: string;
  /** The optional planed deploy time */
  deployAt:
    | Date
    | undefined;
  /** The optional fabric specific image expire time */
  expireAt:
    | Date
    | undefined;
  /** amd64 (default) or arm64 */
  arch: string;
  /** The fabric name */
  fabricName: string;
}

/** SwitchGroupImageUpdate describes the switch group image configurations */
export interface SwitchGroupImageUpdate {
  /** The switch group id */
  switchGroupId: string;
  /** The image update tag */
  tag: string;
  /** The optional planed deploy time */
  deployAt:
    | Date
    | undefined;
  /** The optional fabric specific image expire time */
  expireAt:
    | Date
    | undefined;
  /** amd64 (default) or arm64 */
  arch: string;
  /** The switch group name */
  switchGroupName: string;
  /** The switch group short name */
  shortName: string;
}

/** NodeImageUpdate describes the node image configurations */
export interface NodeImageUpdate {
  /** The node id or name */
  nodeId: string;
  /** optional node name */
  nodeName: string;
  /** The image tag assigned to the node */
  tag: string;
  /** The optional activation time */
  activateAt: Date | undefined;
}

/** FabricSoftwareConfig describes the all software configurations used by a fabric */
export interface FabricSoftwareConfig {
  /** The fabric id */
  fabricId: string;
  /** Software operation mode */
  softwareMode: SoftwareMode;
  /** The fabric's running version */
  runningImage:
    | FabricImageUpdate
    | undefined;
  /** The fabric's target version */
  targetImage:
    | FabricImageUpdate
    | undefined;
  /** The list of node images */
  nodeImages: NodeImageUpdate[];
  /** The list of switch group software configurations */
  switchGroupSwConfs: SwitchGroupSoftwareConfig[];
}

/** SwitchGroupSoftwareConfig describes the software configurations used by a switch group */
export interface SwitchGroupSoftwareConfig {
  /** The fabric id */
  fabricId: string;
  /** The switch group id */
  switchGroupId: string;
  /** The switch group's target version */
  targetImage: SwitchGroupImageUpdate | undefined;
}

export interface ImagePackageInfo {
  /** The package release tag */
  tag: string;
  /** The package name */
  name: string;
  /** H/W architecture (amd64 or arm64). */
  arch: string;
  /** Target platform for the artifact if it is platform-specific (HF6100-32D, HF6100-60L4D). */
  platform: string;
  /** Version defines package version. */
  version: string;
  /** The package download URL */
  url: string;
  /** The package file size */
  sizeBytes: string;
  /** The SHA512/224 hash of the package file */
  sha512: string;
  /** CheckInterval defines image check interval. */
  checkInterval: string;
  /** The cache expiration duration */
  cacheDuration: string;
  /** The package file generation time */
  fileTime: string;
  /** The package expected expiration time */
  expiresAt: string;
  /** The image release document link */
  docLink: string;
  /** The release image type, released, pre-released, test or dev. */
  releaseType: string;
  /** The SHA512/224 hash of the embedded package file. */
  innerSha512: string;
  /** The image availability, all or limited */
  availability: ImageAvailabilityType;
  /** The vendor name (if provided) */
  vendor: string;
}

function createBaseFabricImageUpdate(): FabricImageUpdate {
  return { fabricId: "", tag: "", deployAt: undefined, expireAt: undefined, arch: "", fabricName: "" };
}

export const FabricImageUpdate: MessageFns<FabricImageUpdate> = {
  encode(message: FabricImageUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.tag !== "") {
      writer.uint32(18).string(message.tag);
    }
    if (message.deployAt !== undefined) {
      Timestamp.encode(toTimestamp(message.deployAt), writer.uint32(26).fork()).join();
    }
    if (message.expireAt !== undefined) {
      Timestamp.encode(toTimestamp(message.expireAt), writer.uint32(34).fork()).join();
    }
    if (message.arch !== "") {
      writer.uint32(42).string(message.arch);
    }
    if (message.fabricName !== "") {
      writer.uint32(50).string(message.fabricName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FabricImageUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFabricImageUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tag = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.deployAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.expireAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.arch = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.fabricName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FabricImageUpdate {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      tag: isSet(object.tag) ? globalThis.String(object.tag) : "",
      deployAt: isSet(object.deployAt) ? fromJsonTimestamp(object.deployAt) : undefined,
      expireAt: isSet(object.expireAt) ? fromJsonTimestamp(object.expireAt) : undefined,
      arch: isSet(object.arch) ? globalThis.String(object.arch) : "",
      fabricName: isSet(object.fabricName) ? globalThis.String(object.fabricName) : "",
    };
  },

  toJSON(message: FabricImageUpdate): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.tag !== "") {
      obj.tag = message.tag;
    }
    if (message.deployAt !== undefined) {
      obj.deployAt = message.deployAt.toISOString();
    }
    if (message.expireAt !== undefined) {
      obj.expireAt = message.expireAt.toISOString();
    }
    if (message.arch !== "") {
      obj.arch = message.arch;
    }
    if (message.fabricName !== "") {
      obj.fabricName = message.fabricName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FabricImageUpdate>, I>>(base?: I): FabricImageUpdate {
    return FabricImageUpdate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FabricImageUpdate>, I>>(object: I): FabricImageUpdate {
    const message = createBaseFabricImageUpdate();
    message.fabricId = object.fabricId ?? "";
    message.tag = object.tag ?? "";
    message.deployAt = object.deployAt ?? undefined;
    message.expireAt = object.expireAt ?? undefined;
    message.arch = object.arch ?? "";
    message.fabricName = object.fabricName ?? "";
    return message;
  },
};

function createBaseSwitchGroupImageUpdate(): SwitchGroupImageUpdate {
  return {
    switchGroupId: "",
    tag: "",
    deployAt: undefined,
    expireAt: undefined,
    arch: "",
    switchGroupName: "",
    shortName: "",
  };
}

export const SwitchGroupImageUpdate: MessageFns<SwitchGroupImageUpdate> = {
  encode(message: SwitchGroupImageUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.switchGroupId !== "") {
      writer.uint32(10).string(message.switchGroupId);
    }
    if (message.tag !== "") {
      writer.uint32(18).string(message.tag);
    }
    if (message.deployAt !== undefined) {
      Timestamp.encode(toTimestamp(message.deployAt), writer.uint32(26).fork()).join();
    }
    if (message.expireAt !== undefined) {
      Timestamp.encode(toTimestamp(message.expireAt), writer.uint32(34).fork()).join();
    }
    if (message.arch !== "") {
      writer.uint32(42).string(message.arch);
    }
    if (message.switchGroupName !== "") {
      writer.uint32(50).string(message.switchGroupName);
    }
    if (message.shortName !== "") {
      writer.uint32(58).string(message.shortName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SwitchGroupImageUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSwitchGroupImageUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.switchGroupId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tag = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.deployAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.expireAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.arch = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.switchGroupName = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.shortName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SwitchGroupImageUpdate {
    return {
      switchGroupId: isSet(object.switchGroupId) ? globalThis.String(object.switchGroupId) : "",
      tag: isSet(object.tag) ? globalThis.String(object.tag) : "",
      deployAt: isSet(object.deployAt) ? fromJsonTimestamp(object.deployAt) : undefined,
      expireAt: isSet(object.expireAt) ? fromJsonTimestamp(object.expireAt) : undefined,
      arch: isSet(object.arch) ? globalThis.String(object.arch) : "",
      switchGroupName: isSet(object.switchGroupName) ? globalThis.String(object.switchGroupName) : "",
      shortName: isSet(object.shortName) ? globalThis.String(object.shortName) : "",
    };
  },

  toJSON(message: SwitchGroupImageUpdate): unknown {
    const obj: any = {};
    if (message.switchGroupId !== "") {
      obj.switchGroupId = message.switchGroupId;
    }
    if (message.tag !== "") {
      obj.tag = message.tag;
    }
    if (message.deployAt !== undefined) {
      obj.deployAt = message.deployAt.toISOString();
    }
    if (message.expireAt !== undefined) {
      obj.expireAt = message.expireAt.toISOString();
    }
    if (message.arch !== "") {
      obj.arch = message.arch;
    }
    if (message.switchGroupName !== "") {
      obj.switchGroupName = message.switchGroupName;
    }
    if (message.shortName !== "") {
      obj.shortName = message.shortName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SwitchGroupImageUpdate>, I>>(base?: I): SwitchGroupImageUpdate {
    return SwitchGroupImageUpdate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SwitchGroupImageUpdate>, I>>(object: I): SwitchGroupImageUpdate {
    const message = createBaseSwitchGroupImageUpdate();
    message.switchGroupId = object.switchGroupId ?? "";
    message.tag = object.tag ?? "";
    message.deployAt = object.deployAt ?? undefined;
    message.expireAt = object.expireAt ?? undefined;
    message.arch = object.arch ?? "";
    message.switchGroupName = object.switchGroupName ?? "";
    message.shortName = object.shortName ?? "";
    return message;
  },
};

function createBaseNodeImageUpdate(): NodeImageUpdate {
  return { nodeId: "", nodeName: "", tag: "", activateAt: undefined };
}

export const NodeImageUpdate: MessageFns<NodeImageUpdate> = {
  encode(message: NodeImageUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.nodeId !== "") {
      writer.uint32(10).string(message.nodeId);
    }
    if (message.nodeName !== "") {
      writer.uint32(18).string(message.nodeName);
    }
    if (message.tag !== "") {
      writer.uint32(26).string(message.tag);
    }
    if (message.activateAt !== undefined) {
      Timestamp.encode(toTimestamp(message.activateAt), writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NodeImageUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNodeImageUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.nodeId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nodeName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.tag = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.activateAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NodeImageUpdate {
    return {
      nodeId: isSet(object.nodeId) ? globalThis.String(object.nodeId) : "",
      nodeName: isSet(object.nodeName) ? globalThis.String(object.nodeName) : "",
      tag: isSet(object.tag) ? globalThis.String(object.tag) : "",
      activateAt: isSet(object.activateAt) ? fromJsonTimestamp(object.activateAt) : undefined,
    };
  },

  toJSON(message: NodeImageUpdate): unknown {
    const obj: any = {};
    if (message.nodeId !== "") {
      obj.nodeId = message.nodeId;
    }
    if (message.nodeName !== "") {
      obj.nodeName = message.nodeName;
    }
    if (message.tag !== "") {
      obj.tag = message.tag;
    }
    if (message.activateAt !== undefined) {
      obj.activateAt = message.activateAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NodeImageUpdate>, I>>(base?: I): NodeImageUpdate {
    return NodeImageUpdate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NodeImageUpdate>, I>>(object: I): NodeImageUpdate {
    const message = createBaseNodeImageUpdate();
    message.nodeId = object.nodeId ?? "";
    message.nodeName = object.nodeName ?? "";
    message.tag = object.tag ?? "";
    message.activateAt = object.activateAt ?? undefined;
    return message;
  },
};

function createBaseFabricSoftwareConfig(): FabricSoftwareConfig {
  return {
    fabricId: "",
    softwareMode: 0,
    runningImage: undefined,
    targetImage: undefined,
    nodeImages: [],
    switchGroupSwConfs: [],
  };
}

export const FabricSoftwareConfig: MessageFns<FabricSoftwareConfig> = {
  encode(message: FabricSoftwareConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.softwareMode !== 0) {
      writer.uint32(16).int32(message.softwareMode);
    }
    if (message.runningImage !== undefined) {
      FabricImageUpdate.encode(message.runningImage, writer.uint32(26).fork()).join();
    }
    if (message.targetImage !== undefined) {
      FabricImageUpdate.encode(message.targetImage, writer.uint32(34).fork()).join();
    }
    for (const v of message.nodeImages) {
      NodeImageUpdate.encode(v!, writer.uint32(42).fork()).join();
    }
    for (const v of message.switchGroupSwConfs) {
      SwitchGroupSoftwareConfig.encode(v!, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FabricSoftwareConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFabricSoftwareConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.softwareMode = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.runningImage = FabricImageUpdate.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.targetImage = FabricImageUpdate.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.nodeImages.push(NodeImageUpdate.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.switchGroupSwConfs.push(SwitchGroupSoftwareConfig.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FabricSoftwareConfig {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      softwareMode: isSet(object.softwareMode) ? softwareModeFromJSON(object.softwareMode) : 0,
      runningImage: isSet(object.runningImage) ? FabricImageUpdate.fromJSON(object.runningImage) : undefined,
      targetImage: isSet(object.targetImage) ? FabricImageUpdate.fromJSON(object.targetImage) : undefined,
      nodeImages: globalThis.Array.isArray(object?.nodeImages)
        ? object.nodeImages.map((e: any) => NodeImageUpdate.fromJSON(e))
        : [],
      switchGroupSwConfs: globalThis.Array.isArray(object?.switchGroupSwConfs)
        ? object.switchGroupSwConfs.map((e: any) => SwitchGroupSoftwareConfig.fromJSON(e))
        : [],
    };
  },

  toJSON(message: FabricSoftwareConfig): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.softwareMode !== 0) {
      obj.softwareMode = softwareModeToJSON(message.softwareMode);
    }
    if (message.runningImage !== undefined) {
      obj.runningImage = FabricImageUpdate.toJSON(message.runningImage);
    }
    if (message.targetImage !== undefined) {
      obj.targetImage = FabricImageUpdate.toJSON(message.targetImage);
    }
    if (message.nodeImages?.length) {
      obj.nodeImages = message.nodeImages.map((e) => NodeImageUpdate.toJSON(e));
    }
    if (message.switchGroupSwConfs?.length) {
      obj.switchGroupSwConfs = message.switchGroupSwConfs.map((e) => SwitchGroupSoftwareConfig.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FabricSoftwareConfig>, I>>(base?: I): FabricSoftwareConfig {
    return FabricSoftwareConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FabricSoftwareConfig>, I>>(object: I): FabricSoftwareConfig {
    const message = createBaseFabricSoftwareConfig();
    message.fabricId = object.fabricId ?? "";
    message.softwareMode = object.softwareMode ?? 0;
    message.runningImage = (object.runningImage !== undefined && object.runningImage !== null)
      ? FabricImageUpdate.fromPartial(object.runningImage)
      : undefined;
    message.targetImage = (object.targetImage !== undefined && object.targetImage !== null)
      ? FabricImageUpdate.fromPartial(object.targetImage)
      : undefined;
    message.nodeImages = object.nodeImages?.map((e) => NodeImageUpdate.fromPartial(e)) || [];
    message.switchGroupSwConfs = object.switchGroupSwConfs?.map((e) => SwitchGroupSoftwareConfig.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSwitchGroupSoftwareConfig(): SwitchGroupSoftwareConfig {
  return { fabricId: "", switchGroupId: "", targetImage: undefined };
}

export const SwitchGroupSoftwareConfig: MessageFns<SwitchGroupSoftwareConfig> = {
  encode(message: SwitchGroupSoftwareConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.switchGroupId !== "") {
      writer.uint32(18).string(message.switchGroupId);
    }
    if (message.targetImage !== undefined) {
      SwitchGroupImageUpdate.encode(message.targetImage, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SwitchGroupSoftwareConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSwitchGroupSoftwareConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.switchGroupId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.targetImage = SwitchGroupImageUpdate.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SwitchGroupSoftwareConfig {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      switchGroupId: isSet(object.switchGroupId) ? globalThis.String(object.switchGroupId) : "",
      targetImage: isSet(object.targetImage) ? SwitchGroupImageUpdate.fromJSON(object.targetImage) : undefined,
    };
  },

  toJSON(message: SwitchGroupSoftwareConfig): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.switchGroupId !== "") {
      obj.switchGroupId = message.switchGroupId;
    }
    if (message.targetImage !== undefined) {
      obj.targetImage = SwitchGroupImageUpdate.toJSON(message.targetImage);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SwitchGroupSoftwareConfig>, I>>(base?: I): SwitchGroupSoftwareConfig {
    return SwitchGroupSoftwareConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SwitchGroupSoftwareConfig>, I>>(object: I): SwitchGroupSoftwareConfig {
    const message = createBaseSwitchGroupSoftwareConfig();
    message.fabricId = object.fabricId ?? "";
    message.switchGroupId = object.switchGroupId ?? "";
    message.targetImage = (object.targetImage !== undefined && object.targetImage !== null)
      ? SwitchGroupImageUpdate.fromPartial(object.targetImage)
      : undefined;
    return message;
  },
};

function createBaseImagePackageInfo(): ImagePackageInfo {
  return {
    tag: "",
    name: "",
    arch: "",
    platform: "",
    version: "",
    url: "",
    sizeBytes: "0",
    sha512: "",
    checkInterval: "",
    cacheDuration: "",
    fileTime: "",
    expiresAt: "",
    docLink: "",
    releaseType: "",
    innerSha512: "",
    availability: 0,
    vendor: "",
  };
}

export const ImagePackageInfo: MessageFns<ImagePackageInfo> = {
  encode(message: ImagePackageInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tag !== "") {
      writer.uint32(10).string(message.tag);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.arch !== "") {
      writer.uint32(26).string(message.arch);
    }
    if (message.platform !== "") {
      writer.uint32(34).string(message.platform);
    }
    if (message.version !== "") {
      writer.uint32(42).string(message.version);
    }
    if (message.url !== "") {
      writer.uint32(50).string(message.url);
    }
    if (message.sizeBytes !== "0") {
      writer.uint32(56).int64(message.sizeBytes);
    }
    if (message.sha512 !== "") {
      writer.uint32(66).string(message.sha512);
    }
    if (message.checkInterval !== "") {
      writer.uint32(74).string(message.checkInterval);
    }
    if (message.cacheDuration !== "") {
      writer.uint32(82).string(message.cacheDuration);
    }
    if (message.fileTime !== "") {
      writer.uint32(90).string(message.fileTime);
    }
    if (message.expiresAt !== "") {
      writer.uint32(98).string(message.expiresAt);
    }
    if (message.docLink !== "") {
      writer.uint32(106).string(message.docLink);
    }
    if (message.releaseType !== "") {
      writer.uint32(114).string(message.releaseType);
    }
    if (message.innerSha512 !== "") {
      writer.uint32(122).string(message.innerSha512);
    }
    if (message.availability !== 0) {
      writer.uint32(128).int32(message.availability);
    }
    if (message.vendor !== "") {
      writer.uint32(138).string(message.vendor);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ImagePackageInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseImagePackageInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tag = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.arch = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.platform = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.version = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.url = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.sizeBytes = reader.int64().toString();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.sha512 = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.checkInterval = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.cacheDuration = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.fileTime = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.expiresAt = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.docLink = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.releaseType = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.innerSha512 = reader.string();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.availability = reader.int32() as any;
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.vendor = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ImagePackageInfo {
    return {
      tag: isSet(object.tag) ? globalThis.String(object.tag) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      arch: isSet(object.arch) ? globalThis.String(object.arch) : "",
      platform: isSet(object.platform) ? globalThis.String(object.platform) : "",
      version: isSet(object.version) ? globalThis.String(object.version) : "",
      url: isSet(object.url) ? globalThis.String(object.url) : "",
      sizeBytes: isSet(object.sizeBytes) ? globalThis.String(object.sizeBytes) : "0",
      sha512: isSet(object.sha512) ? globalThis.String(object.sha512) : "",
      checkInterval: isSet(object.checkInterval) ? globalThis.String(object.checkInterval) : "",
      cacheDuration: isSet(object.cacheDuration) ? globalThis.String(object.cacheDuration) : "",
      fileTime: isSet(object.fileTime) ? globalThis.String(object.fileTime) : "",
      expiresAt: isSet(object.expiresAt) ? globalThis.String(object.expiresAt) : "",
      docLink: isSet(object.docLink) ? globalThis.String(object.docLink) : "",
      releaseType: isSet(object.releaseType) ? globalThis.String(object.releaseType) : "",
      innerSha512: isSet(object.innerSha512) ? globalThis.String(object.innerSha512) : "",
      availability: isSet(object.availability) ? imageAvailabilityTypeFromJSON(object.availability) : 0,
      vendor: isSet(object.vendor) ? globalThis.String(object.vendor) : "",
    };
  },

  toJSON(message: ImagePackageInfo): unknown {
    const obj: any = {};
    if (message.tag !== "") {
      obj.tag = message.tag;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.arch !== "") {
      obj.arch = message.arch;
    }
    if (message.platform !== "") {
      obj.platform = message.platform;
    }
    if (message.version !== "") {
      obj.version = message.version;
    }
    if (message.url !== "") {
      obj.url = message.url;
    }
    if (message.sizeBytes !== "0") {
      obj.sizeBytes = message.sizeBytes;
    }
    if (message.sha512 !== "") {
      obj.sha512 = message.sha512;
    }
    if (message.checkInterval !== "") {
      obj.checkInterval = message.checkInterval;
    }
    if (message.cacheDuration !== "") {
      obj.cacheDuration = message.cacheDuration;
    }
    if (message.fileTime !== "") {
      obj.fileTime = message.fileTime;
    }
    if (message.expiresAt !== "") {
      obj.expiresAt = message.expiresAt;
    }
    if (message.docLink !== "") {
      obj.docLink = message.docLink;
    }
    if (message.releaseType !== "") {
      obj.releaseType = message.releaseType;
    }
    if (message.innerSha512 !== "") {
      obj.innerSha512 = message.innerSha512;
    }
    if (message.availability !== 0) {
      obj.availability = imageAvailabilityTypeToJSON(message.availability);
    }
    if (message.vendor !== "") {
      obj.vendor = message.vendor;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ImagePackageInfo>, I>>(base?: I): ImagePackageInfo {
    return ImagePackageInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ImagePackageInfo>, I>>(object: I): ImagePackageInfo {
    const message = createBaseImagePackageInfo();
    message.tag = object.tag ?? "";
    message.name = object.name ?? "";
    message.arch = object.arch ?? "";
    message.platform = object.platform ?? "";
    message.version = object.version ?? "";
    message.url = object.url ?? "";
    message.sizeBytes = object.sizeBytes ?? "0";
    message.sha512 = object.sha512 ?? "";
    message.checkInterval = object.checkInterval ?? "";
    message.cacheDuration = object.cacheDuration ?? "";
    message.fileTime = object.fileTime ?? "";
    message.expiresAt = object.expiresAt ?? "";
    message.docLink = object.docLink ?? "";
    message.releaseType = object.releaseType ?? "";
    message.innerSha512 = object.innerSha512 ?? "";
    message.availability = object.availability ?? 0;
    message.vendor = object.vendor ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000).toString();
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (globalThis.Number(t.seconds) || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
